import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormLabel,
  Image,
  Input,
  InputGroup,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import React, { useState } from 'react';
import Effects from '../../../components/Effects/Effects';
import { IoLogoGoogle } from 'react-icons/io';
import { IMG } from './../../../Content/Content';
import { Link } from 'react-router-dom';
import axios from 'axios';
import Footer from '../../../components/Header/Footer';
import Header from '../../../components/Header/Header';

const Register = () => {
  const [user, setUser] = useState(['']);

  function handleChange(e) {
    const userName = e.target.name;
    const userValue = e.target.value;
    setUser({ ...user, [userName]: userValue });
  }

  function register(e) {
    e.preventDefault();

    axios.post('http://127.0.0.1:5000/user/signup', user).then(res => {
      console.log(res);
    });

    if (user.password === user.confirmPassword) {
    }
  }
  return (
    <VStack>
      <Header/>
      <VStack
        className="signup"
        bg="#fff"
        paddingY="200px"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <VStack
          w="1259px"
          mx="auto"
          bg="#F5F5F5"
          boxShadow="0px 4px 4px 4px rgba(0, 0, 0, 0.25)"
          borderRadius="19px"
          h="auto"
          padding="100px"
          height="100vh"
        >
          {/* Form */}
          <Box w="50%" margin="auto" textAlign="center">
            {/* title */}
            <Box className="form">
              <Box className="top-bar">
                <Text
                  className="title"
                  fontSize="50px"
                  fontFamily={'Poppins, sans-serif'}
                  fontWeight={'600'}
                  lineHeight="75px"
                  color="rgba(0, 0, 0, 0.86)"
                >
                  Glad to see you!
                </Text>
                <Text
                  fontSize="20px"
                  className="sub-title"
                  fontFamily={'Poppins, sans-serif'}
                  fontWeight={'500'}
                  lineHeight="30px"
                  color="rgba(0, 0, 0, 0.86)"
                >
                  Please enter details to continue
                </Text>
              </Box>

              <form onSubmit={register}>
                {/* name and email */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginRight="15px"
                  >
                    <FormLabel
                      htmlFor="firstName"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      First name
                    </FormLabel>
                    <Input
                      type="text"
                      id="firstName"
                      name="firstName"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginLeft="15px"
                  >
                    <FormLabel
                      htmlFor="Email"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Email
                    </FormLabel>
                    <Input
                      type="text"
                      id="Email"
                      name="Email"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Box>
                {/* last name and company name */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginRight="15px"
                  >
                    <FormLabel
                      htmlFor="lastName"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Last name
                    </FormLabel>
                    <Input
                      type="text"
                      id="lastName"
                      name="lastName"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginLeft="15px"
                  >
                    <FormLabel
                      htmlFor="companyName"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Company name
                    </FormLabel>
                    <Input
                      type="text"
                      id="companyName"
                      name="companyName"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Box>
                {/* password and confirm password */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginRight="15px"
                  >
                    <FormLabel
                      htmlFor="password"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Password
                    </FormLabel>
                    <Input
                      type="password"
                      id="password"
                      name="password"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>

                  <InputGroup
                    marginBottom="2rem"
                    marginTop="2rem"
                    display={'flex'}
                    flexDirection={'column'}
                    marginLeft="15px"
                  >
                    <FormLabel
                      htmlFor="confirmPassword"
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                    >
                      Confirm password
                    </FormLabel>
                    <Input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      border="0"
                      borderBottom={' 2px solid rgba(0, 0, 0, 0.28);'}
                      bg="transparent"
                      paddingY={'10px'}
                      h="40px"
                      _focusVisible={{ boxShadow: 'none' }}
                      display={'block'}
                      fontSize="24px"
                      fontFamily={'Poppins, sans-serif'}
                      fontWeight={'500'}
                      lineHeight="36px"
                      color="rgba(0, 0, 0, 0.86)"
                      onChange={handleChange}
                    />
                  </InputGroup>
                </Box>
                <Box>
                  <Button
                    type="submit"
                    bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);"
                    boxShadow={'-2px -6px 3px rgba(0, 0, 0, 0.25)'}
                    borderRadius={'15px'}
                    fontSize={'30px'}
                    fontWeight={'500'}
                    letterSpacing={'-1.13533px'}
                    color="#F5F3EE"
                    display="block"
                    width="100%"
                    paddingY="10px"
                    marginTop="20px"
                    height="auto"
                    _hover={{
                      background:
                        'linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)',
                    }}
                  >
                    Register Now
                  </Button>
                </Box>
              </form>

              <Stack paddingTop="10px">
                <Box display="flex" justifyContent="end" alignItems="center">
                  <Text
                    fontSize="24px"
                    fontFamily={'Poppins, sans-serif'}
                    fontWeight={'500'}
                    lineHeight="36px"
                    color="rgba(0, 0, 0, 0.77)"
                    marginRight="2px"
                  >
                    Already have an account?
                  </Text>
                  <Link to="/login" color="#f6a15d" className="register">
                    {' '}
                    Sign in now
                  </Link>
                </Box>
              </Stack>
            </Box>
          </Box>
        </VStack>

        {/* <Effects bg="#F69963" bottom="0" left="0"/>
                  <Effects bg="linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%);" bottom="0" left="0"/>
                  <Effects bg="#F69963" bottom="0" left="0"/> */}
      </VStack>
      <Footer/>
    </VStack>
  );
};

export default Register;
